// Shared helpers for interpreting displacement-reason ("cause") strings.
// The DTM data stores reasons as semicolon-separated tokens on each row
// (e.g. "Conflict/violence; Natural disaster"); these helpers normalise those
// tokens into the canonical category labels used by the UI so the map filter
// (Map.js) and the reasons toolbar (TopBar.js) agree on matching logic.

export const getCauseCategories = (value) => {
  if (!value) return [];
  const tokens = value
    .split(";")
    .map((token) => token.trim().toLowerCase())
    .filter(Boolean);
  const categories = new Set();
  tokens.forEach((token) => {
    if (token.includes("conflict/violence")) {
      categories.add("Conflict/violence");
    } else if (token.includes("conflict")) {
      categories.add("Conflict");
    }
    if (token.includes("insecurity")) categories.add("Insecurity");
    if (token.includes("economic")) categories.add("Economic");
    if (token.includes("political")) categories.add("Political");
    if (token.includes("natural disaster")) categories.add("Natural disaster");
    if (token.includes("social tension")) categories.add("Social tension");
    if (token.includes("other reasons")) categories.add("Other reasons");
    if (token.includes("other reason")) categories.add("Other reason");
    if (token.includes("no reason for displacement reported"))
      categories.add("No reason for displacement reported");
    if (token.includes("no displacement reported"))
      categories.add("No displacement reported");
  });
  return Array.from(categories);
};

export const normalizeSelectedCause = (selectedCause) => {
  if (!selectedCause) return "";
  const trimmed = selectedCause.trim();
  if (/^Other reason(s)?$/i.test(trimmed)) return trimmed;
  if (/^No reason for displacement reported$/i.test(trimmed)) return trimmed;
  if (/^No displacement reported$/i.test(trimmed)) return trimmed;
  return trimmed.replace(/\s+reasons?$/i, "");
};

export const matchesSelectedCause = (value, selectedCause) => {
  if (!selectedCause || selectedCause === "All" || selectedCause === "None")
    return true;
  const categories = getCauseCategories(value);
  const normalizedSelectedCause = normalizeSelectedCause(selectedCause);
  if (normalizedSelectedCause === "Conflict/violence") {
    return categories.includes("Conflict/violence");
  }
  return categories.includes(normalizedSelectedCause);
};
